import { motion, useAnimate, type AnimationSequence } from 'framer-motion'
import { useEffect } from 'react'
import Marquee from 'react-fast-marquee'
import { useTranslate } from '../../../../hooks/language/use-translate'
import { useGlobalStore } from '../../../../store/global-store'
import type { NotifyGift } from '../../../../types/lives/notifies'

interface Props {
  item: NotifyGift
}

export function Toast({ item }: Props) {
  const toast =
    item?.message?.topGlobal ??
    item?.message?.topSameCountry ??
    item?.message?.topLocal

  const removeNotifyGiftToastEarned = useGlobalStore((state) => {
    return state.removeNotifyGiftToastEarned
  })

  const [scope, animate] = useAnimate()

  const { translate } = useTranslate()

  useEffect(() => {
    const sequence: AnimationSequence = [
      [scope.current, { x: 0 }, { duration: 2 }],
      [scope.current, { x: -window.innerWidth }, { delay: 5, duration: 2 }],
    ]

    if (item) {
      animate(sequence).then(() => removeNotifyGiftToastEarned(item))
    }
  }, [item, scope, animate, removeNotifyGiftToastEarned])

  const userReceivedName =
    toast?.userReceivedName!.length > 5
      ? `${toast?.userReceivedName?.slice(0, 10)}...`
      : toast?.userReceivedName

  return (
    <motion.div
      ref={scope}
      className="mt-32 h-7 w-96 flex flex-row rounded-lg items-center pl-2 text-white border border-white gap-2"
      style={{
        backgroundImage: 'linear-gradient(to right, #4568DC, #3B4781)',
        x: window.innerWidth,
      }}
    >
      <img
        src={toast?.invisibleVisitor ? '' : toast?.imgUser}
        className="w-4 h-4 bg-black rounded-full border"
      />

      <div className="flex flex-rol justify-start items-center min-w-0 w-full">
        <Marquee delay={1} speed={80} style={{ width: '80%' }}>
          <span className="mr-2">
            {toast?.invisibleVisitor ? translate('invisible') : toast?.username}
            &nbsp;{translate('toast-earned-global-sent')}&nbsp;
            {toast?.giftName}&nbsp;{translate('toast-earned-global-to')}&nbsp;
            {userReceivedName}
            &nbsp;{translate('toast-earned-global-and')}&nbsp;
            {translate('toast-earned-global-earned')}&nbsp;
            {toast?.returnTimes}&nbsp;coins&nbsp;
          </span>
        </Marquee>
      </div>

      <span className="colored-text text-3xl bg-clip-text text-transparent font-bold -mr-4 bg-gradient-to-r from-white to-white">
        {parseFloat(String(toast?.returnTimes))}x
      </span>

      <img
        src={toast?.imgGiftFrame ?? toast?.imgGift}
        className="w-16 h-16 -mr-4 -mt-2"
      />
    </motion.div>
  )
}
